import React from 'react';
import ReactTable from 'react-table'
import Axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SearchBar from 'components/common/SearchBar'
import DatatableHelper from 'utils/DatatableHelper'
import { Colors, Sizes, ButtonGroup, Button} from 'react-foundation'
import TableContainer from 'components/common/TableContainer'
import { API } from 'api/APIClient'
import ReactSelect from 'components/common/ReactSelect'
import AppComponent from 'components/common/AppComponent'
import { SectionType } from 'constants/SectionType'
import { Link } from 'react-router-dom'
import StandardModal from 'components/common/StandardModal'
import { NotificationManager } from "react-notifications"
import Modal from "react-responsive-modal"
import DateHelper from 'utils/DateHelper'

export default class ConfigsTable extends AppComponent {

    constructor(props) {
        super(props);

        this.state = {
            items: [],
            searchKey: "",
            organisations: [],
            organisationOptions: [],
            page: 0,
            pageSize: 10,
            sorted: [{id: "id", "desc": true}],
            totalPages: -1,
            isLoading: true,
            filtersAreOpen: false,
            modal: {
                isOpen: false,
                content: null,
                isUploading: false,
                error: null
            }
        };

        this.searchTimer = null;
    }

    componentDidMount() {
        if (this.props.permissions.allOrgs) {
            this.getOrganisationOptions();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.sectionType !== this.props.sectionType) {
            this.fetchItems();
        }
    }

    searchTextDidChange(newValue) {
        this.setState({
            searchKey: newValue || ""
        }, () => {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.fetchItems();
            }, 1000);
        });
    }

    getOrganisationOptions = () => {
        Axios
            .get(API.organisation.getOrganisations, {
                props: {
                    appUsersOnly: 1
                }
            })
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        organisationOptions: res.data.data.organisations.map((item) => { return {value: item.id.toString(), label: item.name} })
                    })
                }
            })
    }


    fetchItems = () => {
        this.setState({
            loading: true
        });

        Axios
            .post(API.sectionConfig.getConfigsDT, {
                    page: this.state.page,
                    pageSize: this.state.pageSize,
                    sorted: this.state.sorted,
                    filters: {
                        search: this.state.searchKey,
                        organisations: this.state.organisations,
                        sectionTypeID: this.props.sectionType
                    }
                }
            )
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        items: res.data.data.rows,
                        totalPages: DatatableHelper.getTotalPages(res.data.data),
                        isLoading: false
                    })
                }
            })
    }

    handleChange = (event) => {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "organisations") {
            this.setState({
                organisations: value
            }, () => {
                this.fetchItems();
            });
        }
    }


    closeModal = (completion) => {
        if (this.state.modal.isOpen) {
            this.setState({
                modal: {
                    isOpen: false,
                    content: null,
                    error: null,
                    isUploading: false
                }
            }, () => {
                if (completion instanceof Function) {
                    completion();
                }
            })
        }
    }

    showDeleteModal = (item) => {

        if (!this.state.modal.isOpen) {
            const content = (
                <StandardModal
                    title="Delete Config"
                    content={(
                        <div>Are you sure to delete <strong>{item.name}</strong> config ? This action cannot be reverted.</div>
                    )}
                    buttons={(
                        <React.Fragment>
                            <button className="button secondary" type="button" onClick={this.closeModal}>
                                Cancel
                            </button>
                            <button className="button alert" type="button" onClick={() => this.handleDeleteItem(item)}>
                                Delete
                            </button>
                        </React.Fragment>
                    )}
                    isUploading={this.state.modal.isUploading}
                />
            );

            this.setState({
                modal: Object.assign({}, this.state.modal, {
                    isOpen: true,
                    content: content
                })
            })
        }
    }

    handleDeleteItem = (item) => {

        if (!this.state.modal.isUploading) {
            this.setState({
                modal: Object.assign({}, this.state.modal, {
                    isUploading: true
                })
            }, () => {

                Axios
                    .post(API.sectionConfig.deleteConfig, {
                        configID: item.id
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.closeModal(() => {
                                this.fetchItems();
                                NotificationManager.success("Config deleted");
                            });
                        }
                        else {
                            this.closeModal(() => {
                                this.fetchItems();
                                NotificationManager.error(res.data.error.desc);
                            });
                        }
                    })
                    .catch(error => {
                        this.closeModal(() => {
                            this.fetchItems();
                            NotificationManager.error(error.response);
                        });
                    });
            })
        }
    }


    render() {

        const columns = [
            {
                Header: 'Name',
                accessor: 'name',
                minWidth: 250
            },
            {
                Header: 'Organisation',
                accessor: 'organisationName',
                width: 180,
                show: this.props.permissions.allOrgs
            },
            {
                Header: 'Campuses',
                width: 180,
                sortable: false,
                Cell: row => row.original.accessList ? Array.from(new Set(row.original.accessList.map(o => o.campusName))).join(", ") : 'Not assigned'
            },
            {
                Header: 'Created At',
                accessor: 'createdAt',
                width: 180,
                Cell: row => {
                    return DateHelper.convertToLocalDateTime(row.value);
                }
            },
            {
                Header: 'Actions',
                Cell: row => {
                    if (this.props.isSelector) {
                        return (
                            <ButtonGroup size={Sizes.TINY}>
                                <Button color={Colors.PRIMARY} onClick={() => { if (this.props.callback) { this.props.callback("click", row.original); }}}>Select</Button>
                            </ButtonGroup>
                        );
                    }

                    return (
                        <ButtonGroup size={Sizes.TINY}>

                            {this.props.permissions.edit &&
                                <Link
                                    to={{
                                        pathname: SectionType.getPath(this.props.sectionType) + "edit",
                                        state: {
                                            sectionType: this.props.sectionType,
                                            item: row.original
                                        }
                                    }}
                                >
                                    <Button color={Colors.PRIMARY}><FontAwesomeIcon icon="edit" /></Button>
                                </Link>}
                            {this.props.permissions.delete &&
                                <Button color={Colors.ALERT} onClick={() => this.showDeleteModal(row.original)}><FontAwesomeIcon icon="trash" /></Button>}
                        </ButtonGroup>
                    )
                },
                maxWidth: 130,
                sortable: false,
                show: this.props.permissions.edit || this.props.permissions.delete
            }
        ]

        const filters = (
            <React.Fragment>
                <div className="cell small-12 medium-6 large-3">
                    <span>Search</span>
                    <SearchBar
                        onDidChange={(newValue) => this.searchTextDidChange(newValue)}
                    />
                </div>
                {this.props.permissions.allOrgs &&
                <div className="cell small-12 medium-6 large-3">
                    <span>Organisations</span>
                    <ReactSelect
                        name="organisations"
                        onChange={this.handleChange}
                        value={this.state.organisations}
                        options={this.state.organisationOptions}
                        isMulti={true}
                        placeholder="All"
                        className="react-select"
                    />
                </div>
                }
            </React.Fragment>

        )

        let buttons = (
            <React.Fragment>
                {this.props.permissions.create &&
                    <Link
                        to={{
                            pathname: SectionType.getPath(this.props.sectionType) + "create",
                            state: {
                                sectionType: this.props.sectionType,
                                permissions: this.props.permissions
                            }
                        }}
                    >
                        <button type="button" className="button small" >Add New Configuration</button>
                    </Link>
                }
            </React.Fragment>
        )

        if (this.props.isSelector) {
            // Do not show buttons for Selector context
            buttons = [];
        }

        const table = (
            <ReactTable
                columns={columns}
                data={this.state.items}
                pages={this.state.totalPages}
                pageSize={this.state.pageSize}
                loading={this.state.isLoading}
                multisort={true}
                manual
                className='-striped'
                onFetchData={(state) => {
                    this.setState({
                        page: state.page,
                        pageSize: state.pageSize,
                        sorted: state.sorted
                    }, () => {
                        this.fetchItems()
                    })
                }}
                SubComponent={row => {

                    let campuses = {};

                    row.original.accessList.forEach(a => {
                        if (!campuses.hasOwnProperty(a.campusName)) {
                            campuses[a.campusName] = [];
                        }

                        campuses[a.campusName].push(a.userRoleName);
                    });

                    return (
                        <div style={{ padding: "20px" }}>
                            <h5>Visibility:</h5>
                            {Object.keys(campuses).map(campus =>
                                <ul>
                                    <li>{campus}</li>
                                    <ul>
                                        {campuses[campus].map(role =>
                                            <li>{role}</li>
                                        )}
                                    </ul>
                                </ul>

                            )}
                        </div>
                    );
                }}
            />
        )

        return (
            <React.Fragment>
                <TableContainer
                    title={this.props.title ? this.props.title : "Configurations"}
                    buttons={buttons}
                    filters={filters}
                    table={table}
                />
                <Modal
                    classNames={{modal:"modal-medium"}}
                    open={this.state.modal.isOpen}
                    modalId="sectionEditorModal"
                    onClose={this.closeModal}
                    center
                >
                    {this.state.modal.content}
                </Modal>
            </React.Fragment>
        );
    }
}